"use client";

import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import { sendCAPIEvent } from "@/lib/meta-capi";

function MetaPixelTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const eventId = crypto.randomUUID();
    const url = window.location.href;
    window.fbq?.("track", "PageView", {}, { eventID: eventId });
    sendCAPIEvent({
      event_name: "PageView",
      event_id: eventId,
      event_source_url: url,
    });
  }, [pathname, searchParams]);

  return null;
}

export default function MetaPixelInit() {
  return (
    <>
      <Script src="/meta-pixel-init.js" strategy="beforeInteractive" />
      <Suspense fallback={null}>
        <MetaPixelTracker />
      </Suspense>
    </>
  );
}
